import { AxiosResponse } from 'axios';
import { BaseService } from '@services/route.service';

export interface GoogleCalendarStatus {
    /// O app do Google está configurado em Integrações.
    available: boolean;
    connected: boolean;
    email?: string | null;

    /// O Google recusou o acesso guardado: precisa conectar de novo.
    expired: boolean;
}

export interface ExternalCalendarEvent {
    id: string;
    title: string;
    start: string;
    end: string;
    allDay: boolean;
}

export class GoogleCalendarService extends BaseService {
    protected get resourceName(): string {
        return 'crm/google-calendar';
    }

    public async status(): Promise<AxiosResponse<{ data: GoogleCalendarStatus }>> {
        return await this.get('status');
    }

    public async connect(): Promise<AxiosResponse<{ data: { ready: boolean; url?: string; reason?: string } }>> {
        return await this.get('connect');
    }

    public async events(from: string, to: string): Promise<AxiosResponse<{ data: ExternalCalendarEvent[] }>> {
        return await this.get('events', { from, to });
    }

    public async disconnect(): Promise<AxiosResponse<void>> {
        return await this.delete('');
    }
}
